// extracted by css-extract-rspack-plugin
export default {"cls1":"CurrentPaperRow-cls1_Box","cls2":"CurrentPaperRow-cls2__v6 CurrentPaperRow-cls1_Box"};